import { render, staticRenderFns } from "./MinuteSignatureTab.vue?vue&type=template&id=3a0709e2&scoped=true"
import script from "./MinuteSignatureTab.vue?vue&type=script&lang=js"
export * from "./MinuteSignatureTab.vue?vue&type=script&lang=js"
import style0 from "./MinuteSignatureTab.vue?vue&type=style&index=0&id=3a0709e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0709e2",
  null
  
)

export default component.exports